var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Player } from './player';
var InworldRecorder = /** @class */ (function () {
    function InworldRecorder(props) {
        this.player = Player.getInstance();
        this.isActive = true;
        this.listener = props.listener;
        this.grpcAudioPlayer = props.grpcAudioPlayer;
        this.grpcAudioRecorder = props.grpcAudioRecorder;
        this.webRtcLoopbackBiDiSession = props.webRtcLoopbackBiDiSession;
    }
    InworldRecorder.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                                audio: {
                                    sampleRate: 16000,
                                    echoCancellation: { ideal: true },
                                    suppressLocalAudioPlayback: { ideal: true },
                                },
                                video: false,
                            })];
                    case 1:
                        _a.recordingStream = _b.sent();
                        return [4 /*yield*/, this.webRtcLoopbackBiDiSession.startSession(this.recordingStream, this.grpcAudioPlayer.getPlaybackStream())];
                    case 2:
                        _b.sent();
                        this.player.setStream(this.webRtcLoopbackBiDiSession.getPlaybackLoopbackStream());
                        this.grpcAudioRecorder.startConvertion(this.webRtcLoopbackBiDiSession.getRecorderLoopBackStream(), function (base64AudioChunk) {
                            if (_this.getIsActive()) {
                                _this.listener(base64AudioChunk);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    InworldRecorder.prototype.setIsActive = function (isActive) {
        this.isActive = isActive;
    };
    InworldRecorder.prototype.getIsActive = function () {
        return this.isActive;
    };
    InworldRecorder.prototype.stop = function () {
        var _a;
        this.grpcAudioRecorder.stopConvertion();
        (_a = this.recordingStream) === null || _a === void 0 ? void 0 : _a.getTracks().forEach(function (track) {
            track.stop();
        });
    };
    // Should be called AFTER any user interaction with the page.
    // Because of strict browser security policies.
    InworldRecorder.prototype.initPlayback = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.grpcAudioPlayer.init()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.webRtcLoopbackBiDiSession.startSession(new MediaStream(), this.grpcAudioPlayer.getPlaybackStream())];
                    case 2:
                        _a.sent();
                        this.player.setStream(this.webRtcLoopbackBiDiSession.getPlaybackLoopbackStream());
                        return [2 /*return*/];
                }
            });
        });
    };
    InworldRecorder.prototype.isRecording = function () {
        return this.grpcAudioRecorder.isRecording();
    };
    InworldRecorder.prototype.isSupported = function () {
        // https://github.com/inworld-ai/inworld/pull/3598
        return navigator.userAgent.indexOf('Firefox') === -1;
    };
    return InworldRecorder;
}());
export { InworldRecorder };
